import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39c00bb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "fixed overflow-x-hidden inset-0 flex justify-center items-center z-50 rounded-lg" }
const _hoisted_3 = { class: "relative mx-auto max-w-2xl rounded-lg" }
const _hoisted_4 = { class: "bg-white p-10 rounded-lg shadow-2xl w-80 text-left" }
const _hoisted_5 = { class: "text-sm text-gris80 pb-4" }
const _hoisted_6 = { class: "text-secondary" }
const _hoisted_7 = { class: "text-red-500" }
const _hoisted_8 = { class: "justify-between" }
const _hoisted_9 = { class: "flex-col inline-flex w-full" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal text-center text-gris80" }, "   ", -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "flex-col inline-flex w-full mt-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Clic aquí", -1))
const _hoisted_15 = { class: "text-secondary text-xs mt-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed z-40 inset-0 opacity-50 bg-black" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_component_Form, {
                onSubmit: _ctx.login,
                "validation-schema": _ctx.schemaForm
              }, {
                default: _withCtx(({ errors }) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", {
                      class: "text-xl text-right cursor-pointer text-primary",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                    }, " ✕ "),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_5, [
                        _createTextVNode(" Ingrese el código de 6 dígitos que hemos enviado al número celular "),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.phoneSms) + ".", 1),
                        _createTextVNode(" Puede tardar en llegar unos segundos ")
                      ]),
                      _createVNode(_component_Field, {
                        name: "otp_code",
                        type: "text",
                        as: "input",
                        class: _normalizeClass(["px-3 h-8 shadow-lg border-2 rounded-md w-full outline-none", { 'border border-primary': errors.otp_code }])
                      }, null, 8, ["class"]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(errors.otp_code), 1),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("button", {
                            type: "submit",
                            class: "w-full text-white text-sm rounded-lg bg-primary py-2 px-3 border-2 float-right outline-none",
                            disabled: _ctx.loginLoading
                          }, [
                            (_ctx.loginLoading)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("Aceptando... ")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("Aceptar")
                                ], 64))
                          ], 8, _hoisted_11)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resendSms && _ctx.resendSms(...args)), ["prevent"])),
                            class: "w-full text-gris120 hover:text-gris80 text-xs border-opacity-0 rounded-lg bg-white py-2 px-3 border-2 float-left outline-none",
                            disabled: _ctx.sendingLoading
                          }, [
                            _hoisted_14,
                            _createTextVNode(" si desea enviar el código nuevamente ")
                          ], 8, _hoisted_13)
                        ])
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_15, " El código ha sido enviado exitosamente. ", 512), [
                      [_vShow, _ctx.sendingSuccess]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ]),
        _hoisted_16
      ]))
    : _createCommentVNode("", true)
}